module.exports = __webpack_public_path__ + "img/2.13bc42e3.jpg";